import React, { Component } from "react";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import { Container, Row, Col, Card, Spinner, InputGroup, FormControl } from "react-bootstrap";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logomarca from '../../assets/images/logo-hns-branco.png';
import Style from './Login.module.css'
import { getCurrentUser } from '../../common/utils';

class TrocarSenha extends Component {
    constructor(props) {
        super(props);
        this.handleResetar = this.handleResetar.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeConfPassword = this.onChangeConfPassword.bind(this);        

        this.state = {
            password: "",
            confPassword: "",
            showPassword: false,
            showConfPassword: false,       
            loading: false,
            programa_dados: [],
        };
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    onChangeConfPassword(e) {
        this.setState({
            confPassword: e.target.value
        });
    }

    toggleShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    toggleShowConfPassword = () => {
        this.setState(state => ({ showConfPassword: !state.showConfPassword }));
    };

    handleResetar(e) {
        const MySwal = withReactContent(Swal) 

        e.preventDefault();

        //verifica se senha e confirmação são iguais
        if(this.state.password != this.state.confPassword){
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>A confirmação de senha deve ser igual a sua senha</p>,
            })

            return false;
        }

        this.setState({
            loading: true
        });

        let payload = {
            'password': this.state.password,
        }        
        
        api({
            method: 'PUT',
            url: '/usuarios/minha_conta/',
            data: payload
        })
        .then(response => {            
            this.setState({
                loading: false,
            })            

            //remove a flag
            localStorage.removeItem("trocar_senha")

            MySwal.fire({
                title: 'Senha alterada',
                icon: 'success',
                html: 'Sua senha foi alterada com sucesso',
                showCloseButton: true,
            }).then((result) => {
                this.props.router.navigate("/");  
                window.location.reload();
            });                      
        })
        .catch(error => {
            let erro_msg = 'Erro ao trocar a senha, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                };
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    }

    render() {      
        const {
            loading,
            password,
            confPassword,
            showPassword,
            showConfPassword
        } = this.state;

        const dados_usuario = getCurrentUser();
        
        return (
            <div className="login-page">
                <Container>
                    <Row>
                        <Col lg={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }} xs={12}>              
                            <div className="text-center mb-4">    
                                <img src={logomarca} alt="Aditus" />
                            </div>       
                            <Card className="mt-5">
                                <Card.Body>
                                    <h4>Informe uma nova senha e confirme abaixo para alterar sua senha</h4>
                                    <form onSubmit={this.handleResetar}>                                        
                                        <div className="form-group mb-3">
                                            <label>Nova Senha</label>
                                            <InputGroup>
                                                <FormControl
                                                type={showPassword ? 'text' : 'password'}
                                                value={password}
                                                required
                                                onChange={this.onChangePassword}
                                                />
                                                <InputGroup.Text
                                                className={Style.clickable}
                                                onClick={this.toggleShowPassword}
                                                >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                        <div className="form-group mb-3">
                                            <label>Confirmação de Senha</label>
                                            <InputGroup>
                                                <FormControl
                                                type={showConfPassword ? 'text' : 'password'}
                                                value={confPassword}
                                                required
                                                onChange={this.onChangeConfPassword}
                                                />
                                                <InputGroup.Text
                                                className={Style.clickable}
                                                onClick={this.toggleShowConfPassword}
                                                >
                                                {showConfPassword ? <FaEyeSlash /> : <FaEye />}
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                        <p>Requisitos da senha: </p>
                                        <ul>
                                            <li>Quantidade de caracteres maior que 8</li>
                                            <li>Uma letra minuscula</li>
                                            <li>Uma letra maiuscula</li>
                                            <li>Um número de 0 a 9</li>
                                            <li>Pelo menos um dos seguintes caracteres $@#$!%*?&</li>
                                        </ul>
                                        <div className="form-group mb-2 text-center">
                                            <button
                                                className="btn btn-first mt-3 btn-block"
                                                disabled={loading}
                                            >
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                )}
                                                <span>Alterar</span>
                                            </button>
                                        </div>                                       
                                    </form>                        
                                </Card.Body>
                            </Card>                                              
                        </Col>
                    </Row>
                </Container>
            </div>
        );
        
    }
}

export default withRouter(TrocarSenha);